<template>
  <div class="body-third-section">
    <p :class="[isSP ? 'text-sp' : 'text-pc']">{{ work.desTitle3 }}</p>
    <p v-viewportChanged="showView" :class="['hidden-element', isSP ? 'info-sp': 'info-pc']">{{ work.desInfo3 }}</p>
    <div
      v-for="(item, index) in work.desContent3"
      :key="index+'_key'"
      :class="['body-third-section-item', { ja: !isZH}]"
    >
      <div class="title">
        <div class="title-black">{{ item.text1 }}</div>
        <span class="title-text">{{ item.text2 }}</span>
      </div>
      <p v-viewportChanged="showView" :class="['hidden-element',isSP ? 'description-sp' : 'description-pc']">
        {{ item.description }}
      </p>
    </div>
    <div v-if="work.desClient3?.isUnderlined" :class="[isSP ? 'underlined-sp' : 'underlined-pc']"></div>
    <template v-if="!isSP">
      <div
        v-viewportChanged="showView"
        v-for="(item, index) in work.desClient3?.clientList"
        :key="index+'_key'"
        class="hidden-element client-pc"
      >
        <div :class="[{ ja: !isZH }]">
          <div class="client-tip">{{ item.tip }}</div>
          <p class="client-title-pc">{{ item.title }}</p>
          <p
            v-for="(it, idx) in item.text"
            :key="'title_'+idx+'_key'"
            class="client-text-pc"
          >
            {{ it }}
          </p>
        </div>
        <div class="team-content-pc">
          <img class="company-img-pc" alt='' :src="getImageUrl(item.teamIntroduce.companyImg)" />
          <p class="company">{{ item.teamIntroduce.company }}</p>
          <p :class="['team', { 'space-wrap': !isSP }]">{{ item.teamIntroduce.team }}</p>
          <div class="user">
            <img class="user-avatar" alt='' :src="getImageUrl(item.teamIntroduce.userAvatar)" />
            <div class="user-info">
              <p class="user-duties">{{ item.teamIntroduce.userDuties }}</p>
              <p class="user-name">{{ item.teamIntroduce.userName }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-viewportChanged="showView"
        v-for="(item, index) in work.desClient3?.clientList"
        :key="index+'_key'"
        class="hidden-element client-sp"
      >
        <div :class="[{ ja: !isZH }]">
          <p class="client-title-sp">{{ item.title }}</p>
          <p
            v-for="(it, idx) in item.text"
            :key="'title_'+idx+'_key'"
            class="client-text-sp"
          >
            {{ it }}
          </p>
        </div>
        <div>
          <div class="client-tip">{{ item.tip }}</div>
          <img class="company-img-sp" alt='' :src="getImageUrl(item.teamIntroduce.companyImg)" />
          <p class="company">{{ item.teamIntroduce.company }}</p>
          <p class="team">{{ item.teamIntroduce.team }}</p>
          <div class="user">
            <img class="user-avatar" alt='' :src="getImageUrl(item.teamIntroduce.userAvatar)" />
            <div class="user-info">
              <p class="user-duties">{{ item.teamIntroduce.userDuties }}</p>
              <p class="user-name">{{ item.teamIntroduce.userName }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { inject } from 'vue';
import useRenderData from '@/composables/useRenderData';
import useIsSP from '@/composables/useIsSP';
import { LOCALES } from '@/constants/constants';

export default {
  props: {
    work: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const { getImageUrl } = useRenderData('network-security');
    const { isSP } = useIsSP();
    const locale = inject('locale');
    return {
      getImageUrl,
      isSP,
      locale,
    };
  },
  computed: {
    isZH() {
      return this.locale === LOCALES.ZH;
    },
  },
};
</script>

<style lang="scss" scoped>
  .body-third-section{
    .title{
      display: flex;
      justify-content: flex-start;
    }
    .body-third-section-item{
      margin-top: 28px;
    }
  }
  .title-black{
    min-width: 58px;
    height: 24px;
    background-color: #000;
    color: #fff;
    font-size: 14px;
    letter-spacing: 0.37px;
    line-height: 24px;
    text-align: center;
    margin-right: 10px;
  }
  .title-text{
    display: inline-block;
    font-size: 20px;
    color: #222222;
    letter-spacing: 0.53px;
    font-weight: 600;
    line-height: 28px;
  }
  .client-tip {
    max-width: 88px;
    height: 24px;
    background-color: #000;
    color: #fff;
    font-size: 14px;
    letter-spacing: 0.37px;
    line-height: 24px;
    text-align: center;
  }
  .company {
    color: #212121;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.43px;
    line-height: 24px;
    margin: 10px 0 8px;
  }
  .team {
    color: #212121;
    font-size: 14px;
    letter-spacing: 0.37px;
    line-height: 20px;
  }
  .space-wrap {
    white-space: pre-line;
  }
  .user {
    display: flex;
    align-items: center;
    margin-top: 24px;
  }
  .user-avatar {
    border: 2px solid #E6E9E9;
    border-radius: 50%;
    width: 160px;
  }
  .user-info {
    flex: 0 0 auto;
    margin-left: 24px;
  }
  .user-duties {
    color: #212121;
    font-size: 16px;
    letter-spacing: 0.43px;
    line-height: 24px;
  }
  .user-name {
    color: #212121;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.43px;
    line-height: 24px;
  }
  .text-pc{
    font-size: 23px;
    color: #222222;
    letter-spacing: 0.61px;
    font-weight: 600;
  }
  .info-pc {
    color: #222222;
    font-size: 16px;
    letter-spacing: 0.43px;
    line-height: 28px;
    margin-top: 24px;
  }
  .underlined-pc {
    border: 1px solid #000000;
    opacity: 0.1;
    margin: 90px 0 48px;
  }
  .description-pc{
    font-size: 16px;
    color: #222222;
    letter-spacing: 0.43px;
    line-height: 28px;
    font-weight: 400;
    margin-top: 12px;
  }
  .client-pc {
    display: flex;
  }
  .client-title-pc {
    color: #222222;
    font-size: 23px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0.61px;
    margin: 14px 0 27px;
  }
  .client-text-pc {
    color: #222222;
    font-size: 16px;
    letter-spacing: 0.43px;
    line-height: 28px;
    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }
  .team-content-pc {
    margin: 39px 0 0 48px;
    flex: 0 0 auto;
  }
  .company-img-pc {
    height: 58px;
  }
  .text-sp{
    font-size: 19px;
    color: #222222;
    letter-spacing: 0.51px;
    line-height: 26px;
    font-weight: 600;
  }
  .info-sp {
    color: #222222;
    font-size: 14px;
    letter-spacing: 0.37px;
    line-height: 28px;
    margin-top: 24px;
  }
  .underlined-sp {
    border: 1px solid #000000;
    opacity: 0.1;
    margin: 60px 0 40px;
  }
  .description-sp{
    font-size: 14px;
    color: #222222;
    letter-spacing: 0.37px;
    line-height: 28px;
    margin-top: 12px;
  }
  .client-sp {
    display: flex;
    flex-direction: column-reverse;
  }
  .client-title-sp {
    color: #222222;
    font-size: 19px;
    font-weight: 600;
    letter-spacing: 0.51px;
    margin: 40px 0 24px;
    line-height: 28px;
  }
  .client-text-sp {
    color: #222222;
    font-size: 14px;
    letter-spacing: 0.37px;
    line-height: 28px;
    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }
  .company-img-sp {
    height: 58px;
    margin-top: 24px;
  }
  .ja .description-sp,
  .ja .client-text-sp {
    font-weight: 300;
  }
  @media only screen and(max-width: 600px) {
    .title-text{
      font-size: 16px;
      line-height: 20px;
    }
  }
</style>
